import { DateTime } from '@ksyos/date-time';
import { Badge, TableCell, TableRow } from '@ksyos/design-system';
import type { ActivityType } from '@common/enums';
import { getDisplayName } from '@common/utils/getDisplayName';
import type { IEmploymentAndServiceRights } from '../ServiceOrganizationPractitioners';
import type { IPractitionerTableProps } from './ServiceOrganizationPractitionerTableBody';
import { translateKey } from '../../../../../translate';
import { FormattedRights } from './ServiceOrganizationPractitionerFormattedRights';

export interface IPriceAgreement {
    amount: number;
    level: 'groepsniveau' | 'organisatieniveau' | 'zorgverlenerniveau';
    type: ActivityType;
}

interface IPractitionerTableRowProps extends IPractitionerTableProps {
    employment: IEmploymentAndServiceRights;
}

export function PractitionerTableRow(props: Readonly<IPractitionerTableRowProps>) {
    const { employment, episodeCategory } = props;

    return (
        <TableRow key={employment.id}>
            <TableCell color={!employment.activeRights ? 'minimal' : 'subtle'}>
                {getDisplayName(employment.practitioner, false, 'familyNameCommaInitials')}
                {isInactive(employment)}
            </TableCell>
            <TableCell color={!employment.activeRights ? 'minimal' : 'subtle'}>
                {translateKey(`professionEnum.${employment.profession}`)}
            </TableCell>
            <TableCell color={!employment.activeRights ? 'minimal' : 'subtle'}>
                <FormattedRights
                    employment={employment}
                    episodeCategory={episodeCategory}
                />
            </TableCell>
            <TableCell color={!employment.activeRights ? 'minimal' : 'subtle'}>
                {employment.activeSince ? DateTime.from(employment.activeSince).format('DD-MM-YYYY') : ''}
            </TableCell>
        </TableRow>
    );

    function isInactive(employmentWithServiceRights: IEmploymentAndServiceRights) {
        if (!employmentWithServiceRights.activeRights) {
            return (
                <Badge
                    color="neutral"
                    size="small"
                    sx={{ ml: 2 }}
                    text={translateKey('common.isInactive')}
                />
            );
        }
    }
}
